// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2lQbK","name":"ConsentHeader_name__ZTf1T","birthday":"ConsentHeader_birthday__Wk0A_","skeleton":"ConsentHeader_skeleton__1Z73j"};